export const actionStatus = {
    pending: 0,
    running: 1,
    complete: 2,
    error: 3,
    jobComplete: 4,
    cancelled: 5,
    skipped: 6
};
